import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useCallback } from 'react';

export const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const executeRecaptchaToken = useCallback(
    async (action: string = 'form_submit'): Promise<string | null> => {
      if (!executeRecaptcha) {
        console.warn('reCAPTCHA not available - proceeding without verification');
        return null;
      }

      try {
        const token = await executeRecaptcha(action);
        return token;
      } catch (error) {
        console.error('reCAPTCHA execution failed:', error);
        return null;
      }
    },
    [executeRecaptcha]
  );

  return { executeRecaptchaToken, isRecaptchaLoaded: !!executeRecaptcha };
};
